// extracted by mini-css-extract-plugin
export default {"container":"SignupPage_container__nHblq","formGroup":"SignupPage_formGroup__cQTTn"};